import * as constants from './constants';

export default (state = constants.defaultState, { type, payload }) => {
	let newState = JSON.parse(JSON.stringify(state));
	newState.dictionaryList = state.dictionaryList;


	switch (type) {
		case constants.USERINFO: {
			newState.userInfo = payload;
			break;
		}
		case 'persist/REHYDRATE':{
			if(payload){
				var incoming = payload.login; // Carts is the name of the reducer
				if (incoming){
					newState= {...newState, ...incoming};
				}
			}
			break;
		}
		case constants.SITELIST: {
			newState.siteList = payload;
			break;
		}
		case constants.CLEAR:{
			newState =  {
				userInfo: {
					token: null,
					customerId: null,
				},
        clientType: 4,
				dictionaryList: [],
				goodInfo:{}
			};
			// alert("123")
			break;
		}
		case constants.MATERIALLIST: {
			newState.materialList = payload;
			break;
		  }
		case constants.CLIENT_TYPE: {
			newState.clientType = payload.clientType;
			break;
		}
		case constants.SEARCHNAME: {
			newState.searchNameList = payload;
			break;
		}
		case constants.PRODUCT: {
			newState.product = payload;
			break;
		}
		case constants.SETTING: {
			newState.setting = payload;
			break;
		}
		default:
			return newState;
	}
	return newState;
}